import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import NavigationLayout from "../../../Components/NavigationLayout";
import Edit from "./Edit";

const Languages = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/therapists/languages" component={List} />
        <Route path="/admin/therapists/languages/new" component={Add} />
        <Route path="/admin/therapists/languages/:id" component={Edit} />
      </Switch>
    </Router>
  );
};
export default Languages;
